import { warehouseHolidayApis } from '@apis/dashboard/warehouseHolidayApis';
import { useMutation } from '@hooks/useMutation';
import { WarehouseHolidayBase } from '@models/WarehouseHoliday';
import { useQueryClient } from '@tanstack/react-query';

export const usePostWarehouseHoliday = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: WarehouseHolidayBase) => {
      const response = await warehouseHolidayApis.post('/dashboard/warehouse-holiday/', {
        body,
      });
      return response[201];
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/warehouse-holiday/`]);
      },
    },
  );
};
